define('glu/grid/filter/badges/filterBadges',['require','../../../collectionView'],function(require) {
    'use strict';

    var CollectionView = require('../../../collectionView');

    return CollectionView.extend({
        className: 'filter-row',

        itemViewOptions: function() {
            return {
                masterCollection: this.masterCollection,
                columns: this.columns,
                filters: this.filters
            };
        },

        initialize: function() {
            this.columns = this.options.columns;
            this.filters = this.options.filters;
            this.masterCollection = this.options.masterCollection;

            this.setColumnsCondition();
        },

        setColumnsCondition: function() {
            this.columns.each(function(column) {
                var filters = this.filters.where({
                    field: column.get('field')
                });

                // A hidden column with filters applied implies that the column should now be visible.
                if (!column.get('condition') && !filters.length) {
                    return;
                }
                column.set('condition', true);
            }, this);
        }
    });
});

